import "./Styles/MainStyles/App.css"
import Container from "./ReactReduxBridge/MarkdownContatiner"

let App = () => {
  return(
    <div>
      <Container />
    </div>
  )
};

export default App;


















/*
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
    </div>
  );
}

export default App;
*/


